module.exports = __webpack_public_path__ + "static/media/clients.42675a5f.png";